import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class IrsipService {

	constructor(public http: HttpClient) { }

	public getIsMaxApplicationExist(profileId): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'irsip/isMaxApplicationExist/' + profileId)
	}

	public cancelApplication(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PUCA + 'das/cancelApplication', payload)
	}
	public saveOrUpdateCourse(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_HRD_PUCA + 'irsip/saveCourses', payload)
	}
	public getApplicationFormData(profileId): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'irsip/getApplicationFormData');
	}
	public checkEligibility(profileId): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'irsip/checkEligibility/' + profileId)
	}

	public getQuestionnare(appId): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'irsip/getQuestionnaire/' + appId);
	}

	public saveQuestionnare(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_HRD_PUCA + 'irsip/saveQuestionnaire', payload);
	}

	public saveApplication(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_HRD_PUCA + 'irsip/saveApplication', payload);
	}

	public getScholarships(appId): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'irsip/getScholarships/' + appId);
	}

	public addScholarships(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_HRD_PUCA + 'irsip/saveScholarships', payload);
	}

	public getHonors(appId): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'irsip/getAwards/' + appId);
	}

	public addHonor(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_HRD_PUCA + 'irsip/saveAwards', payload);
	}

	public getBooks(appId): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'irsip/getPublications/' + appId);
	}

	public addBook(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_HRD_PUCA + 'irsip/savePublications', payload);
	}

	public getFraternities(appId): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'irsip/getFraternities/' + appId);
	}

	public addFraternity(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_HRD_PUCA + 'irsip/saveFraternities', payload);
	}
	public getFileNames(id): Observable<any> {
		return this.http.get(environment.BASE_URL_PROFILE + 'doc/getNestedFileNames/IRSIP/' + id);
	}

	public submitApplication(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_HRD_PUCA + 'irsip/submitApplication', payload);
	}

	public submitApplicationLgsp(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_LGSP + 'irsip/submit-application', payload);
	}

	public getPaymentDetails(appId: number | string): Observable<any> {
		return this.http.get(environment.BASE_URL_LGSP + 'irsip/payment-details/' + appId);
	}

	public verifyPayment(appId: number | string): Observable<any> {
		return this.http.get(environment.BASE_URL_LGSP + 'irsip/payment-verify/' + appId);
	}

	public getApplication(appId): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'irsip/getApplication/' + appId);
	}

	// get subject dropdownList based on field study id
	public getSubjectDropdownList(appId): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'irsip/getSubjects/' + appId);
	}

	// get getBroadFieldDropdownList
	public getBroadFieldDropdownList(): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'irsip/broad-fields');
	}


	// get getNarrowFieldDropdownList
	public getNarrowFieldDropdownList(appId): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'irsip/narrow-fields/' + appId);
	}

	// get getDeatilFieldDropdownList
	public getDetailFieldDropdownList(appId): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'irsip/detailed-fields/' + appId);
	}

	public getUploadedFileIrsip(fileName, applicationId): Observable<any> {
		const httpOptions = {
			responseType: 'blob' as 'json'
		};

		return this.http.get(environment.BASE_URL_PROFILE + "doc/downloadFile/" + fileName + "/IRSIP/" + applicationId, httpOptions);
	}

	public downloadFilesForeignVisit(fileName, applicationId, foreignVisitId): Observable<any> {
		const httpOptions = {
			responseType: 'blob' as 'json'
		};
		let url = environment.BASE_URL_HRD_PUCA + "irsip/downloadDocuments/" + applicationId + "/IRSIP/" + fileName + ".pdf/FOREIGNVISIT/" + foreignVisitId
		return this.http.get(url, httpOptions);
	}

	public downloadFilesLegalDocument(fileName, applicationId): Observable<any> {
		const httpOptions = {
			responseType: 'blob' as 'json'
		};
		let url = environment.BASE_URL_HRD_PUCA + "irsip/downloadDocuments/" + applicationId + "/IRSIP/" + fileName + "/LEGALDOCUMENTS/" + applicationId
		return this.http.get(url, httpOptions);
	}

	public UpdateStatusToLegalDocsUploaded(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_HRD_PUCA + 'irsip/updateStatusToLegalDocsUploaded', payload);
	}

	public downloadFilesTranscript(applicationId, courseId): Observable<any> {
		const httpOptions = {
			responseType: 'blob' as 'json'
		};
		let url = environment.BASE_URL_HRD_PUCA + "irsip/downloadDocuments/" + applicationId + "/IRSIP/transcript.pdf/TRANSCRIPT/" + courseId
		return this.http.get(url, httpOptions);
	}

	public getRemarks(appId): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'irsip/getCommentHistory/' + appId);
	}

	public tAndCAccepted: Subject<boolean> = new Subject();
	public eligibility: Subject<any> = new Subject();
}
